<template>
  <div class="addBankContainer">
    <div :class="AgentIsShow == true ? 'container' : 'settingContainer'">
      <div
        class="flex-row bankBottom"
        v-if="bankCardStatus !== null && !bankCardStatus.status"
      >
        <div class="bankWidth"></div>
        <div style="flex: 1; margin: auto">
          <div class="flex-column AddCard">
            <div class="bankTitle">添加银行卡</div>
            <span style="color: #9f9f9f"
              >需要绑定银行卡号和个人信息才能发工资</span
            >
            <!-- 商户号统一蓝色 -->
            <div style="margin-top: 25px; width: 100%">
              <div class="submit" @click="onSubmit(1)">
                <button class="button blue">+添加个体工商户</button>
              </div>
              <!-- 个人银行统一红色 -->
              <div class="bottom submit" @click="onSubmit(2)">
                <button class="button">+添加个人银行</button>
              </div>
            </div>
            <div class="bankDesc">
              <!-- <van-radio-group v-model="checked"></van-radio-group> -->
              <van-checkbox
                icon-size="16px"
                name="check"
                v-model="checked"
                checked-color="#ff6274"
                shape="square"
              >
              </van-checkbox>
              <span style="margin-left: 5px">
                绑定银行卡需同意
                <span class="bankMessageColor" @click="onMessage"
                  >《平台销售协议声明》</span
                >
              </span>
            </div>
          </div>
        </div>

        <div class="bankWidth"></div>
      </div>
      <div
        v-if="bankCardStatus !== null && bankCardStatus.status"
        :class="AgentIsShow == true ? 'AgentShowBetween' : 'flex-between'"
      >
        <div class="flex-row bankTop">
          <div class="bankWidth"></div>
          <div style="flex: 1; margin: auto" @click="detail">
            <div :class="bankCardStatus.color == 1 ? 'blueBankColor' : 'red'">
              <div class="flex">
                <!--<div class="whiteBorder">
               <div class="bankImage">
                <img src="../../../../assets/images/gs.png" alt="" />
              </div> 
            </div>-->
                {{ bankMessage.openingBank }}
              </div>
              <!-- style="margin-left: 48px" -->
              <div class="flexBetween">
                <div style="word-break: break-all">
                  {{ bankMessage.bankNumber }}
                </div>
              </div>
            </div>
          </div>
          <div class="bankWidth"></div>
        </div>
        <div @click="onMessage" class="statement">
          <div class="statementCenter">平台销售协议声明</div>
        </div>
      </div>
      <!-- <van-cell title="解绑" is-link @click="onUnbound" /> -->
    </div>
  </div>
</template>
<script>
import {
  CellGroup,
  Form,
  Field,
  Notify,
  Button,
  DatetimePicker,
  Popup,
  Toast,
  Picker,
  Dialog,
  Search,
  ActionSheet,
  RadioGroup,
  Radio,
  Checkbox,
} from "vant";
import { mapGetters, mapActions } from "vuex";

import service from "../../../api/bank/index";
export default {
  components: {
    [CellGroup.name]: CellGroup,
    [Form.name]: Form,
    [Field.name]: Field,
    [Notify.name]: Notify,
    [Button.name]: Button,
    [DatetimePicker.name]: DatetimePicker,
    [Popup.name]: Popup,
    [Toast.name]: Toast,
    [Picker.name]: Picker,
    [Dialog.name]: Dialog,
    [Search.name]: Search,
    [ActionSheet.name]: ActionSheet,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Checkbox.name]: Checkbox,
  },
  data() {
    return {
      checked: false,
      bankMessage: {},
      // bankNumber: "",
      // lookShow: false,
      isColor: 0,
    };
  },
  computed: {
    ...mapGetters(["userInfo", "agentShow", "bankCardStatus"]),
    AgentIsShow() {
      return this.agentShow == null ? false : this.agentShow.isShow;
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapActions(["saveBankStatus"]),
    init() {
      console.log(this.bankCardStatus.cardStatus, "card");
      if (this.bankCardStatus !== null && this.bankCardStatus.status) {
        service.get().then((res) => {
          if (res.statusCode == 200) {
            let obj = {
              save: true,
              cardStatus: true,
              color: res.data.bankType,
            };
            this.saveBankStatus(obj);
            this.isColor = res.data.bankType;
            this.bankMessage = res.data;
          } else {
            Toast(res.errors);
          }
        });
      }
    },
    onMessage() {
      // 跳转到隐私协议
      this.$router.push("bankPrivacy");
    },
    detail() {
      this.$router.push({
        name: "detailBankCard",
        query: { IsShow: false },
      });
      let obj = {
        save: true,
        cardStatus: true,
        IsShow: false,
        color: this.bankCardStatus.color,
      };
      this.saveBankStatus(obj);
    },
    onSubmit(type) {
      if (this.checked) {
        this.isColor = type;
        this.$router.push({
          name: "employeeMessage",
          query: { type: type },
        });
      } else {
        Toast("需勾选同意才可添加银行卡");
      }
    },
  },
};
</script>
<style lang="less" scoped>
@deep: ~">>>";

.addBankContainer {
  // height: calc(100% - 46px);
  overflow: auto;
  display: flex;
  flex-direction: column;

  .statement {
    .statementCenter {
      text-align: center;
      color: #e8414e;
      text-decoration: underline;
    }
    padding: 4vw;
  }

  .bankImage {
    width: 29px;
    height: 29px;
    margin-left: 4.5px;
    margin-top: 4.5px;
  }
  .flex-between {
    flex-direction: column;
    min-height: 94vh;
  }
  .AgentShowBetween {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
    min-height: calc(94vh - 12.8vw);
  }
  .bankWidth {
    width: 15px;
  }
  .bankTop {
    margin-top: 10px;
    width: 100%;
    // .flex {
    //   height: 38px;
    // }
  }
  .flexBetween {
    width: auto;
    margin-top: 14px;
    // margin-left: 48px;
  }
  .bankBottom {
    margin-top: 33px;
  }
  .AddCard {
    background: #fff;
    border-radius: 10px;
    min-height: 62vw;
    padding: 9px 24px;
  }
  .bankTitle {
    font-weight: bold;
    color: #343434;
    font-size: 21px;
    height: 42px;
    line-height: 42px;
  }
  .blueBankColor {
    height: 20.5vw;
    padding: 3.6vw 5.6vw 0;
    color: #fefefe;
    border-radius: 10px;
    background: #2a6add;
  }
  .blue {
    background: #2a6add;
  }
  .bankMessageColor {
    color: #e8414e;
  }
  .bankDesc {
    margin-top: 12px;
    font-size: 12px;
    display: flex;
    .van-checkbox {
      width: 10vw;
    }
  }
  .red {
    background: #e8414e;
    min-height: 14vw;
    padding: 4.6vw 5.6vw 4.6vw;
    color: #fefefe;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .bottom {
    height: 42px;
  }
  .submit {
    width: 100%;
  }
  .button {
    width: 100%;
    height: 42px;
    margin: auto;
    border-radius: 5px;
    margin-bottom: 13px;
  }
}
</style>
